import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { initializeStore } from '../services/PurchaseService';
export const usePurchase = () => {
    const dispatch = useDispatch();
    const products = useSelector((state) => state.purchase.products);
    const loading = useSelector((state) => state.purchase.loading);
    const error = useSelector((state) => state.purchase.error);
    // Initialize the IAP store only once
    useEffect(() => {
        initializeStore(dispatch);
    }, [dispatch]); // Dependency array ensures this runs only once per component lifecycle
    return {
        products,
        loading,
        error,
    };
};
